import { yupResolver } from "@hookform/resolvers/yup";
import { MediaDirectoryKeys } from "constants/enums";
import { useDirectUploadToS3 } from "libs/directUpload";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormField, Input, RichTextEditor, Switch } from "ui";

import { faqItemSchema } from "../../../helpers";
import { FAQPreview } from "../../FAQPreview";
import { FAQItemFormProps, FAQItemFormValues } from "./FAQItemForm.types";

import styles from "./FAQItemForm.module.scss";

const FAQItemForm = ({
  formId,
  defaultValues,
  onSubmit
}: FAQItemFormProps) => {
  const { t } = useTranslation();
  const { uploader } = useDirectUploadToS3();

  const {
    control,
    register,
    handleSubmit,
    watch,
    formState: { errors }
  } = useForm<FAQItemFormValues>({
    resolver: yupResolver(faqItemSchema),
    defaultValues
  });

  const questionWatch = watch("question");
  const answerWatch = watch("answer");

  const handleUploadImage = async (file: File): Promise<string | null> => {
    const media = await uploader(file, {
      directoryKey: MediaDirectoryKeys.Admin
    });

    return media?.url ?? null;
  };

  return (
    <form id={formId} onSubmit={handleSubmit(onSubmit)} className={styles.form}>
      <div className={styles.form_fields}>
        <Input
          {...register("question")}
          label={t("Question")}
          placeholder={t("Enter Question")}
          errorMessage={errors.question?.message}
        />

        <Controller
          control={control}
          name="answer"
          render={({ field: { value, onChange } }) => (
            <RichTextEditor
              defaultValue={value}
              onChange={(nextValue) => onChange(nextValue)}
              label={t("Answer")}
              errorMessage={errors.answer?.message}
              onUploadImage={handleUploadImage}
            />
          )}
        />

        <Controller
          control={control}
          name="isEnabled"
          render={({ field: { value, onChange } }) => (
            <FormField label={t("Visible in the app")}>
              <div className={styles.form_switch}>
                <Switch checked={value} onChange={onChange} />
              </div>
            </FormField>
          )}
        />
      </div>

      <FAQPreview question={questionWatch} answer={answerWatch} />
    </form>
  );
};

export default FAQItemForm;
